import { UserExportKind } from '@fullstory/client-api';
import { SegmentedControlOptionType } from '@fullstory/components';
import { intl } from '@fullstory/intl';
import { PlatformIcon } from '../SessionListItem';
import { SessionTypes } from './types';
import { Platform, SegmentDefinition } from '@fullstory/proto/fs/api/segment';
import { Var } from '@fullstory/proto/fs/api/vars';
import { assertExhaustive } from '@fullstory/typeutils';
import { Duration } from '@fullstory/proto/google/protobuf';

export const USER_OVERLAY_URL_PATH = 'user';
export const UNKNOWN = intl.formatMessage({ defaultMessage: 'UNKNOWN', id: 'uTM3YG' });
export const SERVER = intl.formatMessage({ defaultMessage: 'Server', id: 'F/6VqP' });
export const ALL_SESSIONS: SegmentedControlOptionType = {
  id: SessionTypes.All,
  label: intl.formatMessage({ defaultMessage: 'All Sessions', id: '9Fv6NY' }),
};
export const MATCHING_SESSIONS: SegmentedControlOptionType = {
  id: SessionTypes.MatchingSessions,
  label: intl.formatMessage({ defaultMessage: 'Matching Activity', id: 'Ei3znS' }),
};
export const MATCHING_CLIPS: SegmentedControlOptionType = {
  id: SessionTypes.MatchingClips,
  label: intl.formatMessage({ defaultMessage: 'Matching Clips', id: 'Ml/xuK' }),
};
export const AllTimeRangeSegmentDefinition: SegmentDefinition = {
  constraints: {
    inOrder: false,
    inSameSession: false,
    platform: Platform.PLATFORM_INVALID,
    timeRange: { startTime: '', endTime: '' },
    completeSessions: false,
    withinTime: Duration.zero,
    eventThresholds: [],
  },
  excludeConstraints: null,
  userProperties: [],
  excludeUserProperties: [],
  behaviors: [],
  excludeBehaviors: [],
};

export const getOfflineServerVaribleStrings = (serverVars: Var): string => {
  const oneof = Var.val_oneof(serverVars);
  if (!oneof) {
    return '';
  }
  switch (oneof.opt) {
    case Var.val.bool:
    case Var.val.date:
    case Var.val.int:
    case Var.val.real:
    case Var.val.str: {
      return oneof.val ? oneof.val.toString() : '';
    }
    case Var.val.bools:
    case Var.val.dates:
    case Var.val.ints:
    case Var.val.reals:
    case Var.val.strs: {
      return oneof.val ? oneof.val.elements.join(', ') : '';
    }
    default: {
      return assertExhaustive(oneof);
    }
  }
};

export const getExportUserUrl = (appId: string, userId: string, kind: UserExportKind): string =>
  `/export/userActivity?kind=${kind}&appId=${encodeURIComponent(appId)}&userId=${userId}`;

export const lastMatchingDeviceToPlatformEnum = (device: string): PlatformIcon => {
  switch (device) {
    case 'Mobile':
      return 'device-mobile';
    case 'Tablet':
      return 'device-tablet';
    case 'Desktop':
      return 'device-desktop';
    case 'Robot':
      return 'device-robot';
    case 'Server':
      return 'device-server';
    case 'Unknown':
      return 'device-unknown';
    default:
      return 'device-unknown';
  }
};
